import { render, staticRenderFns } from "./OutputProfilePermissionForm.vue?vue&type=template&id=38da6e32"
import script from "./OutputProfilePermissionForm.vue?vue&type=script&lang=js"
export * from "./OutputProfilePermissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports